// extracted by mini-css-extract-plugin
export default {"strip":"ViewingAsStrip_strip__IIzQZ"};